// src/components/cloud/FileBreadcrumbs.jsx
import React from 'react';
import './cloud.css';

const FileBreadcrumbs = ({ path, onNavigate }) => {
    const parts = path ? path.split('/') : [];

    const handleNavigate = (index) => {
        const newPath = parts.slice(0, index + 1).join('/');
        onNavigate(newPath);
    };

    return (
        <div className="breadcrumbs">
            <span onClick={() => onNavigate('')}>Home</span>
            {parts.map((part, index) => (
                part && (
                    <React.Fragment key={index}>
                        <span className="separator">/</span>
                        <span onClick={() => handleNavigate(index)}>{part}</span>
                    </React.Fragment>
                )
            ))}
        </div>
    );
};

export default FileBreadcrumbs;